<template>
    <section
        class="popup fixed top-0 left-0 w-full h-full py-20 z-2000 overflow-y-auto transition-all !duration-800"
        :class="{'!opacity-0 !pointer-events-none' : !showPopup}"
        style="background-color:rgba(13, 13, 13, .82)"
    >

        <div class="w-full max-w-[calc(100%-3rem)] sm:max-w-xl md:max-w-xl lg:max-w-3xl xl:max-w-4xl mx-auto p-10 md:p-14 xl:p-16 2.5xl:py-20 bg-black absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">

            <button @click="closePopup" class="popup-close absolute top-6 right-6 md:top-8 md:right-8" type="button">
                <img class="w-[20px] h-[20px]" alt="icona" width="40" height="40" src="/images/svg/close.svg"/>
            </button>

            <h2 class="text-white text-3.5xl sm:text-4xl md:text-4xl lg:text-4xl xl:text-5xl 2xl:text-6xl 2.5xl:text-6xl 3.5xl:text-6xl tracking-[3px] mx-auto uppercase relative -left-[3px] mb-6 mt-8 md:mt-4">
                {{$root.translateString('enter-the-wine-club')}}
            </h2>

            <div class="relative w-full mb-10 xl:mb-14 text-center">
                <p class="text-secondary-400 text-lg xl:text-xl 2.5xl:text-1.5xl !leading-snug">
                    {{$root.translateString('enter-the-wine-club-text')}}
                </p>
            </div>

            <div class="flex w-full flex-col items-center mb-5 md:mb-0 space-y-5 text-center">
                <a :href="linkRegister" class="border border-primary-400 px-6 1.5xl:px-8 py-3 text-white relative font-alternate text-sm tracking-[3px] group uppercase hover:bg-primary-400/10 transition-all w-[280px] mx-auto">
                    <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-400 group-hover:left-6 transition-all"></span>
                    {{$root.translateString('register-now')}}
                    <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-400 group-hover:right-6 transition-all"></span>
                </a>
                <a :href="linkLogin" class="underline text-white/50 hover:text-white/100 text-xl transition-all">
                    {{$root.translateString('have-an-account')}}
                </a>
            </div>

        </div>

    </section>
</template>

<script>
    export default {

        props: ['linkRegister', 'linkLogin'],

        data() {
            return {
                showPopup: false,
            }
        },

        methods: {

            setCookie(key, value, expiry) {
                let expires = new Date();
                expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
            },

            getCookie(key) {
                let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            },

            closePopup() {
                document.querySelector('body').classList.remove('overflow-hidden')
                this.showPopup = false
            }

        },

        mounted() {

            if(this.getCookie('wineClubPopup') == null) {
                setTimeout(() => {
                    document.querySelector('body').classList.add('overflow-hidden')
                    this.showPopup = true
                    this.setCookie('wineClubPopup', '1', '1');
                }, 4000)
            }

        }

    }
</script>

<style lang="scss" scoped>

</style>
